module.exports = __webpack_public_path__ + "img/keyboard_80_no_led.d44540cf.png";